import PropTypes from 'prop-types';
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Divider, Paper, Typography } from '@material-ui/core';
import FormElement from './FormElement';
import styled from 'styled-components';

const Buffer = styled.div`
    min-height: 100px;
`;

const BuildingSite = ({ formElements, editFormElement, deleteFormElement }) => (
    <Droppable droppableId="building-site" type="ROW" direction="vertical">
        {(prov) => (
            <Paper
                elevation={0}
                ref={prov.innerRef}
                {...prov.droppableProps}
                style={{ minHeight: '100px'}}
            >
                <Typography variant={'h4'}>Form Editor</Typography>
                <Divider style={{ marginBottom: '10px' }} />
                {formElements.map((item, index) => (
                    <FormElement
                        editFormElement={editFormElement}
                        deleteFormElement={deleteFormElement}
                        index={index}
                        item={item}
                    />
                ))}
                <Buffer />
            </Paper>
        )}
    </Droppable>
);

export default BuildingSite;

BuildingSite.propTypes = {
    deleteFormElement: PropTypes.func.isRequired,
    editFormElement: PropTypes.func.isRequired,
    formElements: PropTypes.array.isRequired,
};
